import { testStrategyModule } from './modules/test-strategy';
import { automationFrameworksModule } from './modules/automation-frameworks';
import { cicdTestingModule } from './modules/cicd-testing';
import { performanceTestingModule } from './modules/performance-testing';

export const testingAutomationCourse = {
  id: 'enterprise-testing-automation',
  title: 'Enterprise Testing & QA Automation',
  description: 'Comprehensive testing strategies, automation, and quality assurance for enterprise software',
  level: 'intermediate',
  totalDuration: '16 hours',
  image: '/api/placeholder/400/300',
  prerequisites: ['Software development experience'],
  learningOutcomes: [
    'Implement comprehensive testing strategies and automation',
    'Design effective test plans and quality metrics',
    'Set up CI/CD pipelines with automated testing',
    'Conduct security and performance testing'
  ],
  modules: [
    { ...testStrategyModule, order: 1, estimatedTime: 60 },
    { ...automationFrameworksModule, order: 2, estimatedTime: 90 },
    { ...cicdTestingModule, order: 3, estimatedTime: 75 },
    { ...performanceTestingModule, order: 4, estimatedTime: 45 }
  ]
};